// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".authenticate[data-v-40980182]  .v-slide-group__content{height:37px}.authenticate[data-v-40980182]  .v-tabs-slider-wrapper{margin-right:12px}.authenticate[data-v-40980182]  .v-tab{font-size:18px;letter-spacing:0;min-width:0;padding:0;text-transform:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
